<template>
  <div
    :class="[
      'relative w-full overflow-hidden sm:object-scale-down sm:object-center sm:rounded-lg bg-slate-100 dark:bg-zinc-800',
      isMobile ? 'h-72' : 'flex items-center justify-center content-wrapper',
    ]"
    data-testid="viewer-content-pdf"
  >
    <iframe v-if="!isMobile" :src="iframeSrc" class="pdf-viewer__iframe" />
    <object v-else :data="objectSrc" type="application/pdf" class="pdf-viewer__object" data-testid="pdf-viewer-object">
      <div class="flex flex-col items-center justify-center w-full h-full gap-3 p-6 text-center" data-testid="pdf-viewer-fallback">
        <p class="text-sm text-zinc-500 dark:text-zinc-400">This browser can't display the PDF inline.</p>
        <a :href="src" target="_blank" rel="noopener noreferrer">
          <Button type="solid" variant="blue" text="Open PDF" />
        </a>
      </div>
    </object>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { Button } from '@/storybook';
import { useMobileDetection } from '@/composables/useMobileDetection';

const props = defineProps<{ src: string }>();

const { isMobile } = useMobileDetection();

const iframeSrc = computed(() => props.src.split('#')[0]);

const objectSrc = computed(() => {
  const base = props.src.split('#')[0];
  return `${base}#toolbar=0&page=1`;
});
</script>

<style scoped>
.pdf-viewer__iframe {
  @apply block w-full h-full border-0;
}

.pdf-viewer__object {
  @apply block w-full h-full;
}
</style>
